import React, {useState} from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import { popinfo } from "component/Fancybox/Fancybox";
import api from "api";

const ComponentDisallowMsg = connect(stateMap) (props => {
    const [disallowMessage, setDisallowMessage]   = useState(false);
    const [isLoading, setIsLoading]         = useState(true);

    const ToggleAllowMessage = (e) => {
        if(!props.auth.user)
        {
            return;
        }
        
        setDisallowMessage(!disallowMessage);

        api('/Config/DisallowMessaging', 'post', {
            disallow_msg : e.target.checked
        }, 'Bearer ' + props.auth.token)
            .then(response => {
                setDisallowMessage(response.is_disallowd);
            })
            .catch(error => {
                popinfo('error', 'Allow Messaging', error);
            })

        
    }

    useEffect(() => {
        if(!props.auth.user)
        {
            return
        }

        setIsLoading(true);

        api('/Config/DisallowMessaging', 'get', {}, 'Bearer ' + props.auth.token)
            .then(response => {
                setIsLoading(false);
                setDisallowMessage(response.is_disallowd);
            })
            .catch(error => {
                setIsLoading(false);
                popinfo('error', 'Retrieving Allow Messaging Config.', error);
            })


    }, [props.auth.user])

    return (
        isLoading ? <span className="skeleton"></span> :    
        <label className="switch-button">
            <input 
                type="checkbox"
                checked={disallowMessage == 1}
                onChange={ToggleAllowMessage}
            />
            <span className="slider round"></span>
        </label>
    )
});

export { ComponentDisallowMsg }